import React from 'react';

export interface AddressFieldsValue {
  street: string;
  city: string;
  state: string;
  zip: string;
  addressType?: string;
}

interface AddressFieldsProps {
  value: AddressFieldsValue;
  onChange: (value: AddressFieldsValue) => void;
  disabled?: boolean;
  showAddressType?: boolean;
}

const inputStyle: React.CSSProperties = {
  padding: '9px 12px', border: '1px solid #d1d5db', borderRadius: '6px',
  fontSize: '14px', fontFamily: 'inherit', width: '100%', boxSizing: 'border-box',
};
const labelStyle: React.CSSProperties = { fontSize: '13px', fontWeight: 600, color: '#374151', display: 'block', marginBottom: 6 };
const groupStyle: React.CSSProperties = { marginBottom: 12 };

export default function AddressFields({ value, onChange, disabled, showAddressType }: AddressFieldsProps) {
  return (
    <div>
      <div style={groupStyle}>
        <label style={labelStyle}>Street</label>
        <input
          type="text"
          style={inputStyle}
          placeholder="123 Main St"
          value={value.street}
          disabled={disabled}
          onChange={(e) => onChange({ ...value, street: e.target.value })}
        />
      </div>
      <div style={{ display: 'flex', gap: 12, marginBottom: 12 }}>
        <div style={{ flex: 1 }}>
          <label style={labelStyle}>City</label>
          <input
            type="text"
            style={inputStyle}
            placeholder="Minneapolis"
            value={value.city}
            disabled={disabled}
            onChange={(e) => onChange({ ...value, city: e.target.value })}
          />
        </div>
        <div style={{ width: 90 }}>
          <label style={labelStyle}>State</label>
          <input
            type="text"
            style={inputStyle}
            placeholder="MN"
            maxLength={2}
            value={value.state}
            disabled={disabled}
            onChange={(e) => onChange({ ...value, state: e.target.value.toUpperCase() })}
          />
        </div>
        <div style={{ width: 110 }}>
          <label style={labelStyle}>ZIP</label>
          <input
            type="text"
            style={inputStyle}
            placeholder="55401"
            value={value.zip}
            disabled={disabled}
            onChange={(e) => onChange({ ...value, zip: e.target.value })}
          />
        </div>
      </div>
      {showAddressType && (
        <div style={groupStyle}>
          <label style={labelStyle}>Address Type</label>
          <select
            style={inputStyle}
            value={value.addressType || 'primary'}
            disabled={disabled}
            onChange={(e) => onChange({ ...value, addressType: e.target.value })}
          >
            <option value="primary">Primary</option>
            <option value="billing">Billing</option>
            <option value="shipping">Shipping</option>
          </select>
        </div>
      )}
    </div>
  );
}
